import "twin.macro";

import { useFormContext, useWatch } from "react-hook-form";

import {
  Button,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import OptionsMenu from "@components/Utility/OptionsMenu";
import { FaIcon } from "@features/ui";

const ProgramStatusActions = ({
  handleSave,
  handleCopyProgram,
}: {
  handleSave: () => void;
  handleCopyProgram: () => void;
}) => {
  const { setValue } = useFormContext();
  const status = useWatch({ name: "status" });
  const isActive = useWatch({ name: "isActive" });

  const isCompleteActive = status !== "draft" && isActive;

  const handleActivateProgram = () => {
    if (status === "draft") {
      setValue("status", "complete");
    } else {
      setValue("isActive", true);
    }
    handleSave();
  };

  const handleDeactivateProgram = () => {
    setValue("isActive", false);
    handleSave();
  };

  return (
    <div tw="flex items-center gap-2">
      {!isCompleteActive && (
        <Button variant="contained" onClick={handleActivateProgram}>
          Activate Program
        </Button>
      )}
      <OptionsMenu edge="end" title="More">
        <ListItemButton tw="py-1" className="group" onClick={handleCopyProgram}>
          <ListItemIcon tw="min-w-8 text-lg">
            <FaIcon icon="clone" tw="group-hover:text-blue-500" />
          </ListItemIcon>
          <ListItemText>Copy Program</ListItemText>
        </ListItemButton>
        {isCompleteActive && (
          <ListItemButton
            tw="py-1"
            className="group"
            onClick={handleDeactivateProgram}
          >
            <ListItemIcon tw="min-w-8 text-lg">
              <FaIcon icon="close" tw=" group-hover:text-red-500" />
            </ListItemIcon>
            <ListItemText>Deactivate Program</ListItemText>
          </ListItemButton>
        )}
      </OptionsMenu>
    </div>
  );
};

export default ProgramStatusActions;
